/* eslint-disable @typescript-eslint/no-explicit-any */
class LimitMap {
  private map: Map<string | number, any>;

  private queue: Array<string>;

  private limit: number;

  constructor(options?: { limit: number }) {
    this.map = new Map();
    this.queue = [];
    this.limit = options?.limit || 50;
  }

  get(key: string | number) {
    return this.map.get(key);
  }

  get size() {
    return this.map.size;
  }

  set(key: string, value: any) {
    if (this.size >= this.limit) {
      const q = this.queue.shift();
      if (q) {
        this.delete(q);
      }
    }
    this.queue.push(key);
    return this.map.set(key, value);
  }

  has(key: string | number) {
    return this.map.has(key);
  }

  delete(key: string | number) {
    return this.map.delete(key);
  }
}
export default LimitMap;
